import { render, staticRenderFns } from "./studentView.vue?vue&type=template&id=762b25a8&scoped=true"
import script from "./studentView.vue?vue&type=script&lang=js"
export * from "./studentView.vue?vue&type=script&lang=js"
import style0 from "./studentView.vue?vue&type=style&index=0&id=762b25a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762b25a8",
  null
  
)

export default component.exports